import { Box } from "@mui/material";
import Spinner from "components/common/Spinner";
import { endPoints } from "const/endPoints";
import { fetchWithToken } from "helpers/fetch";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AddTeacherModal } from "./AddTeacherModal";
import { DeleteTeacherModal } from "./DeleteTeacherModal";
import { TeacherCard } from "./TeacherCard";

const Teachers = () => {
  //**** get teacher by course id *****/
  const course = useParams().courseTitle;
  const cleanCourse = course && course.replaceAll("-", " ").toLowerCase();
  const courses = useSelector((state) => state.courses.courses);
  const courseId = courses.find(
    (c) => c.title.toLowerCase() === cleanCourse
  ).id;

  const [teachers, setTeachers] = useState("");
  const [loading, setLoading] = useState(true);

  const getTeachers = async (courseId) => {
    const response = await fetchWithToken(
      `${endPoints.get_teachers_by_course}/${courseId}`
    );
    const body = await response.json();
    if (response.status === 200) {
      setTeachers(body);
      setLoading(false);
    } else {
      setTeachers([]);
      setLoading(false);
    }
  };

  const [flag, setFlag] = useState(false);

  useEffect(() => {
    getTeachers(courseId);
    console.log("falg", flag);
  }, [flag]);

  if (loading) {
    return (
      <div
        style={{
          width: "200px",
          height: "200px",
        }}
      >
        cargando...
      </div>
    );
  }
  return (
    <div 
      className="teachers-isolated-container"
      style={{
        // Complete CSS isolation
        isolation: "isolate",
        position: "relative",
        zIndex: "1",
        contain: "layout style paint",
        width: "100%",
        padding: "20px",
        backgroundColor: "white",
        boxSizing: "border-box",
        fontFamily: "inherit",
        // Reset any potential conflicts
        transform: "translateZ(0)",
        WebkitTransform: "translateZ(0)",
        willChange: "auto",
      }}
    >
      
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          isolation: "isolate",
          contain: "layout style",
        }}
      >
        <DeleteTeacherModal
          courseId={courseId}
          setFlag={setFlag}
          teachers={teachers}
        />
        <AddTeacherModal courseId={courseId} setFlag={setFlag} />
      </Box>
      
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          padding: "1rem",
          marginTop: "1rem",
          isolation: "isolate",
          contain: "layout style",
        }}
      >
        {teachers.length !== 0 ? (
          teachers.map((teacher) => {
            return (
              <TeacherCard
                key={teacher.id}
                teacher={teacher}
                courseId={courseId}
                setFlag={setFlag}
                flag={flag}
              />
            );
          })
        ) : (
          <div style={{
            textAlign: "center",
            padding: "40px",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            border: "1px dashed #dee2e6",
            margin: "20px 0",
          }}>
            <h1 style={{ color: "#6c757d", margin: "0" }}>
              No hay profesores para este curso
            </h1>
          </div>
        )}
      </Box>
    </div>
  );
};

export default Teachers;